import React, { createContext, useState, useContext } from 'react';

interface AddNewLocationModalContextType {
  isAddOtherLocationChosen: boolean;
  setIsAddOtherLocationChosen: (value: boolean) => void;
}

const AddNewLocationModalContext = createContext<
  AddNewLocationModalContextType | undefined
>(undefined);

export const AddNewLocationModalProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [isAddOtherLocationChosen, setIsAddOtherLocationChosen] =
    useState(false);

  return (
    <AddNewLocationModalContext.Provider
      value={{
        isAddOtherLocationChosen,
        setIsAddOtherLocationChosen,
      }}
    >
      {children}
    </AddNewLocationModalContext.Provider>
  );
};

export const useAddNewLocationModalContext = () => {
  const context = useContext(AddNewLocationModalContext);
  if (context === undefined) {
    throw new Error(
      'useAddNewLocationModalContext must be used within an AddNewLocationModalProvider',
    );
  }
  return context;
};
